import Swal from 'sweetalert2';
import './styles.css';

export const Toast = (title, icon = 'success') => {
  Swal.fire({
    position: 'bottom-end',
    icon,
    toast: true,
    title,
    showConfirmButton: false,
    timer: 5000,
    customClass: {
      container: 'toast-notify',
    },
  });
};
